var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    width: 58,
    height: 58,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m45.6 20.1v17.4c0 4.5-3.7 8.1-8.1 8.1h-17.4c-4.5 0-8.2-3.6-8.2-8.1v-17.4c0-4.5 3.7-8.1 8.2-8.1h17.4c4.4 0 8.1 3.6 8.1 8.1zm-2.9 0.6c0-3.2-2.6-5.8-5.8-5.8h-16.3c-3.2 0-5.8 2.6-5.8 5.8v16.2c0 3.2 2.6 5.8 5.8 5.8h16.3c3.2 0 5.8-2.6 5.8-5.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m37.5 28.8c0 4.8-3.9 8.7-8.7 8.7-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.7 8.7-8.7 4.8 0 8.7 3.9 8.7 8.7zm-2.9 0c0-3.2-2.6-5.8-5.8-5.8-3.2 0-5.8 2.6-5.8 5.8 0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m38 21.3c-0.9 0-1.7-0.8-1.7-1.8 0-0.9 0.8-1.7 1.7-1.7 1 0 1.8 0.8 1.8 1.7 0 1-0.8 1.8-1.8 1.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m45.1 57.5h-32.7c-6.8 0-12.3-5.5-12.3-12.3v-32.8c0-6.7 5.5-12.2 12.3-12.2h32.7c6.8 0 12.3 5.5 12.3 12.2v32.8c0 6.8-5.5 12.3-12.3 12.3zm-32.7-55.1c-5.6 0-10.1 4.5-10.1 10v32.8c0 5.5 4.5 10 10.1 10h32.7c5.6 0 10.1-4.5 10.1-10v-32.8c0-5.5-4.5-10-10.1-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.954c31441032bb5dcea7e1650883a83d.svg";
export { ForwardRef as ReactComponent };